import React from 'react';
import { isEmpty, map } from 'lodash';
import classnames from 'classnames';

import { getLabel } from 'utils/getLabel';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { WIDGET_ERROR_TYPE } from 'constants/common';
import { widgetError as WidgetError } from 'ui/views/widgets/widgetError';
import { button as Button } from 'modules/button';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { cSrOrderListNotesLineItem as CSrOrderListNotesLineItem } from 'ui/views/widgets/cSROrderListNotesLineItem';
 *
 * // render
 * <CSrOrderListNotesLineItem propName='propValue'/>
 */
export const cSrOrderListNotesLineItemSuccess = ( props ) => {

    return (
            <div className='ui-c-sr-order-list-notes-line-item'>
                <div className='ui-c-sr-order-list-notes-line-item__list'>

                    { isEmpty( props.items ) ? (
                        <WidgetError type={ WIDGET_ERROR_TYPE.NO_DATA_FOUND} />
                    ) : (
                        <>
                            { map( props.items, ( item, itemIndex ) => (
                                <div key={ item.id + itemIndex } className='ui-c-sr-order-list-notes-line-item__list__table'>
                                    <div className='ui-c-sr-order-list-notes-line-item__list__table__title'>
                                        { getLabel( props.displayDateText ) } : { item.noteDate }
                                    </div>
                                    <div className='ui-c-sr-order-list-notes-line-item__list__table__description'>
                                        { item.comment }
                                    </div>
                                </div>
                            ) ) }
                        </>
                    ) }
                    
                </div>
                

                <div className='ui-c-sr-order-list-notes-line-item__actions'>
                        { map( props.actions, action => {
                            return (
                                <Button
                                    key={ action.name }
                                    { ...action }
                                    outline={ 'cancel' !== action.name ? true: false }
                                    size='large'
                                    className='ui-c-sr-order-list-notes-line-item__actions__action'
                                    onClick={'cancel' !== action.name ? () => props.onAddClick( true ) : () => props.onCancelClick() }
                                />
                            );
                        } ) }
                    </div>
            </div>
    );
};

// set display name
cSrOrderListNotesLineItemSuccess.displayName = 'cSrOrderListNotesLineItemSuccess';

// set default props
cSrOrderListNotesLineItemSuccess.defaultProps = {};

/*******************************/

// preloader view
export const cSrOrderListNotesLineItemPreloader = ( props ) => {

    // widget class name
    const widgetClassName = classnames( 'ui-c-sr-order-list-notes-line-item-preloader', props.className );

    return (
        <div className={widgetClassName}>
            { map( [ 1, 2, 3 ], ( item ) => {
                    return (
                        <div key={ item } className="ui-c-sr-order-list-notes-line-item-preloader__card">
                            <div className='ui-c-sr-order-list-notes-line-item-preloader__card__parent'/>
                            <div className='ui-c-sr-order-list-notes-line-item-preloader__card__children'/>
                        </div>
                    );
                } )
            }
        </div>
    );
};

// set display name
cSrOrderListNotesLineItemPreloader.displayName = 'cSrOrderListNotesLineItemPreloader';

// set default props
cSrOrderListNotesLineItemPreloader.defaultProps = {};

// prop types
cSrOrderListNotesLineItemPreloader.propTypes = {};

/*******************************/

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { cSrOrderListNotesLineItem as cSrOrderListNotesLineItem } from 'ui/views/widgets/cSrOrderListNotesLineItem';
 *
 * // render
 * <cSrOrderListNotesLineItem propName='propValue'/>
 */
export const cSrOrderListNotesLineItem = withNetworkState( cSrOrderListNotesLineItemPreloader, cSrOrderListNotesLineItemSuccess );

